import { useEffect, useState } from 'react';
import { useRxCollection } from 'rxdb-hooks';

import { useMst } from '../../mobx-models/Root';
import { sentryCaptureException } from '../../utilities';
import { RxdbCollectionName } from '../rxdbCollectionName';
import { SignAndStampUserLevelCollection, SignAndStampUserLevelDocument } from './queryBuilder';

export const useSignAndStampUserLevel = () => {
  const { SiteDiscipline } = useMst();
  const signAndStampUserLevelCollection: SignAndStampUserLevelCollection = useRxCollection(
    RxdbCollectionName.SIGN_AND_STAMP_USER_LEVEL,
  );

  const [signAndStampUserLevelInitialized, setSignAndStampUserLevelInitialized] =
    useState<boolean>(false);

  useEffect(() => {
    if (signAndStampUserLevelCollection) {
      setSignAndStampUserLevelInitialized(true);
    }
  }, [signAndStampUserLevelCollection]);

  const getSignAndStampUserLevel = async (): Promise<SignAndStampUserLevelDocument[]> => {
    if (!signAndStampUserLevelCollection) return [];
    let signAndStampUserLevel: SignAndStampUserLevelDocument[];
    try {
      const site = SiteDiscipline.siteId;
      const discipline = SiteDiscipline.disciplineId;
      const queryObj = {
        selector: { $and: [{ siteId: site }, { disciplineId: discipline }, { isDelete: 'False' }] },
      };

      signAndStampUserLevel = await signAndStampUserLevelCollection?.find(queryObj).exec();
      return signAndStampUserLevel;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(
        '🚀 ~ file: useSignAndStampUserLevel.ts ~ line 25 ~ getSignAndStampUserLevel ~ error',
        error,
      );
      // console logs will be removed once sentry implementation is done
      sentryCaptureException(
        error,
        '~ file: useSignAndStampUserLevel.tsx ~ line 25 ~ getSignAndStampUserLevel ~',
      );
      throw new Error(`error ${error}`);
    }
  };

  return {
    signAndStampUserLevelInitialized,
    signAndStampUserLevelCollection,
    getSignAndStampUserLevel,
  };
};
export default useSignAndStampUserLevel;
